import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  meta: {
    name: ''
  },
  header: {
    userNo: 0,
    accessToken: ''
  },
  selectedRoom: {
    roomNo: '',
    orderNo: 0,
    user: []
  },
  room: {
    page: 1,
    limit: 10,
    totalPage: 2,
    nextId: null,
    roomType: null,
    data: [],
    chatTab: null,
    isLoading: false
  },
  chats: {
    page: 1,
    limit: 10,
    totalPage: 2,
    data: []
  },
  shouldIMoveScroll: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
